import { Box, Stack, Typography } from '@mui/material';

import { useColorTokens } from '@/app/themes';
import { TriangleAlert } from '@/shared/components/icons';

interface MapEmptyProps {
  headingText?: string;
  subHeadingText?: string;
}

const MapNoData = ({
  headingText = 'No data to show',
  subHeadingText = 'There is no data available for the parameters selected.',
}: MapEmptyProps) => {
  const { yellow } = useColorTokens();
  return (
    <Stack
      direction='row'
      gap={1.5}
      p={2}
      sx={{
        borderRadius: 1,
        border: 1,
        borderColor: yellow[100],
        backgroundColor: yellow[5],
      }}
    >
      <TriangleAlert fontSize='small' sx={{ color: yellow[200] }} />
      <Box>
        <Typography variant='body1' component='h2' sx={{ color: yellow[200] }}>
          {headingText}
        </Typography>
        <Typography
          variant='body14'
          component='p'
          fontWeight={400}
          pt={0.75}
          sx={{ color: yellow[200] }}
        >
          {subHeadingText}
        </Typography>
      </Box>
    </Stack>
  );
};

export default MapNoData;
